import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { Dict } from "app/utils/Dict";
import React, { useEffect } from "react";
import { MenuSubConsultasNotaFiscal, MenuSubConsultasNotaFiscalContainer } from "./MenuSubConsultasNotaFiscalContainer";


export const useMenuSubConsultasNotaFiscal = (props: MenuSubConsultasNotaFiscal) => {

    const onRenderizarMenuSubConsultasNotaFiscal = (passos?: Dict<string, () => void>) => {

        if (props.notaFiscalSelecionada == null) {
            removerComponenteReact("menu-sub-consulta-nota-orcamento-pesquisa-react")
        } else {
            renderizarComponentReact(
                <MenuSubConsultasNotaFiscalContainer
                    orcamentoSelecionado={props.orcamentoSelecionado}
                    notaFiscalSelecionada={props.notaFiscalSelecionada}
                    onSelecionadoMenu={() => {
                        $("[container]").hide();
                    }}
                    onVoltar={props.onVoltar}
                    passos={passos ?? props.passos}
                />,
                "menu-sub-consulta-nota-orcamento-pesquisa-react",
                true
            );
        }
    }

    useEffect(() => {
        setTimeout(() => onRenderizarMenuSubConsultasNotaFiscal());
        return () => {
            removerComponenteReact("menu-sub-consulta-nota-orcamento-pesquisa-react");
        };
    }, [props.notaFiscalSelecionada]);

    return onRenderizarMenuSubConsultasNotaFiscal;
}